import { TRootState } from 'Redux/Reducers';
import User           from 'Domain/Models/User/User';

export const getCurrentUser = (state: TRootState) =>
  // @ts-ignore
  state.user.currentUser || new User({});
